<template>
<div class="bodyStyle">
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>注册账号</span>
      <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
    </div>
     <div>
       <el-form :model="registeForm" :rules="rules" ref="registeForm" label-width="150px" class="demo-ruleForm">
         <el-form-item label="登录手机号" prop="username">
           <el-input v-model="registeForm.username" placeholder="请输入手机号"></el-input>
         </el-form-item>
         <el-form-item label="登录密码" prop="password">
           <el-input v-model="registeForm.password" placeholder="请输入登录密码"></el-input>
         </el-form-item>
<!--         <el-form-item label="您的姓名" prop="teacher_name">
           <el-input v-model="registeForm.teacher_name" placeholder="请输入您的姓名"></el-input>
         </el-form-item> -->
         <el-form-item>
           <el-button type="primary" @click="submitForm('registeForm')">立即注册</el-button>
           <el-button @click="resetForm('registeForm')">重填</el-button>
            <el-button @click="backForm()">返回</el-button>
         </el-form-item>
       </el-form>
     </div>
  </el-card>
</div>
</template>

<script>
export default {
  data () {
    return {
      registeForm: {
        username: '',
        password: ''
      }

    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this

          if (this.registeForm.username === '') {
             this.$message.error('请输入做为账号的手机号码')
             return
          }

          if (!this.isPhone(this.registeForm.username)) {
             this.$message.error('电话号码格式不正确，请重新输入')
             return
          }

          if (this.registeForm.password === '') {
             this.$message.error('请输入密码')
             return
          }

          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          // 注册接口
          var requestUrl = '/form/web/_registe.jsp'
          this.axios.get(requestUrl, {
            params: {
              username: that.registeForm.username,
              password: that.registeForm.password
            }
          }).then(function (response) {
            console.log(response.data.result)
            var result = response.data.result
            if (result === '1') {
              that.$message('注册成功,请用刚才注册的账号登录！')
              that.$router.push('/')
            } else {
              that.$message.error('注册失败！账号已经存在，换个试试！')
            }

            load.close()
          })
            .catch(function (error) {
              console.log(error)
              load.close()
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    backForm () {
      this.$router.push('/')
    }
  }
}
</script>

<style>

  .bodyStyle{
    display: flex;
    justify-content: center;
    padding: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/registe.vue